const headers = {
  name: "Credit Notes",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "filter",
      name: "customer",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Customer",
      api: "get-all-customers",
      value: null,
      options: null,
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/sales/credit-notes/add",
    },
  ],
   navigate: {
    tabs: [
      {
        name: "Invoices",
        path: "/app/sales",
      },
       {
        name: "Returns",
        path: "/app/sales/returns",
      },
      {
        name: "Quotes",
        path: "/app/sales/quotes",
      },
      {
        name: "Credit Notes",
        path: "",
      },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;